import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { NitroSingleSelect } from 'nitro-components';
import { SEARCHTYPE } from './store/TYPES';

export const GlobalSearchTypeDropdown = ({ selected, options, onSelect }) => (
  <NitroSingleSelect
    value={selected}
    options={options}
    mandatory
    bold
    action={onSelect}
  />
);

GlobalSearchTypeDropdown.propTypes = {
  selected: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({}))
};

GlobalSearchTypeDropdown.defaultProps = {
  selected: 'Registration',
  options: SEARCHTYPE.map(i => ({ label: i, value: i }))
};

export default connect()(GlobalSearchTypeDropdown);



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/GlobalSearchTypeDropdown.js